import { useEffect, useState } from "react"
import { BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { HexMap } from "../../Data/HexMap/HexMap"
import { Music } from "../../Util/Music/Music"
import { TransformTranslate } from "../../Util/Transform/Transform"
import { HxMapGroup } from "../HxMap/HxMapGroup"
import { Note } from "../../Data/HexMap/Note"
import { useNoteName, useNoteNames } from "../../Project/ProjectStore"
import { OutlineBox } from "../OutlineBox/OutlineBox"
import { useNotePlayer } from "../../Sound/SoundStore"
import './ModesComp.scss'
import { Modes, useModalScaleNoteNames } from "../../Util/Music/Modes"
import { BsFilePlay } from "react-icons/bs"
import { NotesSelect } from "../NoteButtons/NotesSelect"
import { NotePlayer } from "../../Sound/NotePlayer"

export interface ModeSection{
    title:string,
    subtitle:string,
    showRelativeNumbers:boolean
}
export function ModesComp(props:{tonic:number}){
    const tonicName:string = useNoteName(props.tonic)
    const intro:ModeSection = { title:' ', 
                                subtitle:` `,
                                showRelativeNumbers:false 
                              }
    const ionian:ModeSection = { title:'Ionian (Major)', 
                                subtitle:'The Standard Major',
                                showRelativeNumbers:false 
                              }
    const dorian:ModeSection = { title:'Dorian', 
                                subtitle:'The Light Minor',
                                showRelativeNumbers:false 
                              }
    const phrygian:ModeSection = { title:'Phrygian', 
                                subtitle:'The Heavy Minor',
                                showRelativeNumbers:false 
                              }
    const lydian:ModeSection = { title:'Lydian', 
                                subtitle:'The Light Major',
                                showRelativeNumbers:false 
                              }
    const mixolydian:ModeSection = { title:'Mixolydian', 
                                subtitle:'The Heavy Major',
                                showRelativeNumbers:false 
                              }
    const aeolian:ModeSection = { title:'Aeolian (Minor)', 
                                subtitle:'The Standard Minor',
                                showRelativeNumbers:false 
                              }
    const locrian:ModeSection = { title:'Locrian', 
                                subtitle:'The Heavy Inharmonic Minor',
                                showRelativeNumbers:false 
                              }
    const screens:ModeSection[] = [intro, ionian, dorian, phrygian, lydian, mixolydian, aeolian, locrian]
    const [screenIndex, setScreenIndex] = useState(0)
    const width:number = 300
    const height:number = 300
    const radius:number = 90
    const notePlayer:NotePlayer = useNotePlayer()
    const getModalIndex = () => {
        return screenIndex - 1
    }
    const notes:string[] = useModalScaleNoteNames(props.tonic, getModalIndex(), true)
    const getNoteNames = () => {
        const noteNames:JSX.Element[] = []
        notes.forEach((note:string, index:number)=>{
            const divider:string = (index < 7) ? ' - ' : ''
            noteNames.push(<span key={index} style={{fontWeight:'bold', fontSize:20}}>{note}{divider}</span>)
        })
        return noteNames

    }
    const getMap = () => {
        const hilitedPosition:number = screenIndex - 1
        let mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:props.tonic, radius:radius})
        if(screenIndex > 0){
            mapData.notes.forEach((note:Note, index:number)=>{
                const offset:number = hilitedPosition
                const relativePosition:number = (index - offset + 7) % 7
                note.secondaryLabel = String(relativePosition + 1)
            })
            mapData.notes[hilitedPosition].selectedState = Note.SelectedState_Hilited
        }
        return mapData
    }
    const onModeButtonClick = (scrIndex:number) => {
        setScreenIndex(scrIndex)
    }
    const playModalScale = () => {
        if(screenIndex === 0) return
        const modalScale:number[] = Modes.getModalScale(props.tonic, getModalIndex(), true)
        notePlayer.playNotes(modalScale, true, 300)
    }
    const ModeButton = (props:{index:number, title:string}) => {
        const ordinal:string = (props.index > 0) ? ((props.index) + ': ') + props.title: props.title
        const selectedClass:string = (props.index === screenIndex) ? 'selected' : ''
        return <button className={selectedClass} onClick={()=>{onModeButtonClick(props.index)}}>
                    {ordinal}
                </button>
    }
    const Scale = () => {
        if(screenIndex === 0){ return null}
        return(
            <div>
                {getNoteNames()}
            </div>
        )
    }
    const onNoteClick = (note:Note) => { setScreenIndex(note.params.noteIndex + 1) }
    const getTitle = () => {
        if(screenIndex === 0) return ''
        const num:string = `${screenIndex}`
        const title:string = screens[screenIndex].title
        const subtitle:string = screens[screenIndex].subtitle
        return `${num} : ${title}`
    }
    const getSubtitle = () => {
        return screens[screenIndex].subtitle
    }
    return(
        <div>
                <div className={'modes lesson'}>{/* 
                    <div><NotesSelect tonic={tonic} onChange={onTonicChange}/></div> */}

                    <div style={{height:30, fontSize:24, fontWeight:'bold'}}>{getTitle()}</div>
                    <div style={{height:30, fontSize:22, marginBottom:20}}>{getSubtitle()}</div>
                    <div style={{marginTop:0}}>
                    <svg width={width} height={height} className={''}>
                        <g transform={TransformTranslate(width/2,height/2)}>
                            <HxMapGroup onNoteClick={onNoteClick} hexMap={getMap()}></HxMapGroup>
                        </g>
                    </svg>
                    </div>
                    <div style={{height:35, marginTop:30}}>
                        <Scale/>
                    </div>
                </div>
        </div>
    )
}